import { render, staticRenderFns } from "./OrderingContactsForm.vue?vue&type=template&id=6fb84fb7&lang=pug&"
import script from "./OrderingContactsForm.vue?vue&type=script&lang=js&"
export * from "./OrderingContactsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports